'use strict';

var styled = require('styled-components');
var component = require('../Banner/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const borderLeftColorByVariant = {
    error: theme => theme.designTokens.toastErrorBorderLeftColor,
    info: theme => theme.designTokens.toastInfoBorderLeftColor,
    success: theme => theme.designTokens.toastSuccessBorderLeftColor,
    warning: theme => theme.designTokens.toastWarningBorderLeftColor,
};
const StyledBanner = styled__default.default(component.Banner) `
  border: none;
  border-left-style: solid;
  border-left-width: ${({ theme }) => theme.designTokens.toastBorderLeftWidth};
  border-left-color: ${({ theme, variant }) => borderLeftColorByVariant[variant](theme)};
`;
const Toaster = styled__default.default.div `
  position: ${({ position }) => position};
  top: ${({ theme, top }) => top || theme.designTokens.toasterOffsetTop};
  right: ${({ theme }) => theme.designTokens.toasterOffsetRight};
  width: ${({ theme }) => theme.designTokens.toasterWidth};
  z-index: ${({ theme }) => theme.designTokens.toasterZIndex};
`;
const Styled = {
    Banner: StyledBanner,
    Toaster,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
